import type { Genre } from '@/types';

export const genres: Genre[] = [
  {
    key: 'romance',
    name: '爱情',
    desc: '从怦然心动到双向奔赴，收录高甜浪漫的韩式爱情剧集。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20cinematic%20portrait%20of%20an%20elegant%20young%20couple%20sharing%20a%20tender%20moment%20in%20soft%20golden%20hour%20light%2C%20warm%20blush%20and%20amber%20tones%2C%20dreamy%20bokeh%20background%2C%20emotional%20romantic%20atmosphere%2C%20high%20detail%20editorial%20photography%2C%20no%20text&width=600&height=800&seq=kd-genre-romance&orientation=portrait',
  },
  {
    key: 'thriller',
    name: '悬疑',
    desc: '层层反转与烧脑谜题，带你走进最紧张刺激的悬疑世界。',
    image: 'https://readdy.ai/api/search-image?query=Moody%20cinematic%20portrait%20of%20a%20silhouetted%20figure%20in%20a%20dark%20narrow%20alley%2C%20cold%20teal%20shadows%20with%20a%20single%20warm%20amber%20rim%20light%2C%20mysterious%20tense%20atmosphere%2C%20dramatic%20smoke%20and%20fog%2C%20high%20detail%20noir%20photography%2C%20no%20text&width=600&height=800&seq=kd-genre-thriller&orientation=portrait',
  },
  {
    key: 'history',
    name: '历史',
    desc: '宫廷权谋与家国史诗，重现朝鲜半岛的恢弘历史画卷。',
    image: 'https://readdy.ai/api/search-image?query=Grand%20cinematic%20portrait%20of%20a%20traditional%20Korean%20palace%20courtyard%20in%20misty%20dawn%20light%2C%20layered%20tiled%20roofs%20and%20ornate%20hanbok%20silhouette%2C%20deep%20red%20and%20bronze%20tones%2C%20epic%20historical%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-genre-history&orientation=portrait',
  },
  {
    key: 'fantasy',
    name: '奇幻',
    desc: '跨越时空与传说的浪漫幻想，开启不平凡的奇幻之旅。',
    image: 'https://readdy.ai/api/search-image?query=Dreamlike%20fantasy%20cinematic%20portrait%20of%20a%20figure%20standing%20under%20a%20vast%20star%20filled%20sky%2C%20glowing%20particles%20and%20soft%20violet%20amber%20nebula%2C%20ethereal%20romantic%20magical%20atmosphere%2C%20surreal%20high%20detail%20art%2C%20no%20text&width=600&height=800&seq=kd-genre-fantasy&orientation=portrait',
  },
  {
    key: 'urban',
    name: '都市',
    desc: '写字楼、霓虹与烟火气，讲述现代都市人的情感与成长。',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20cinematic%20portrait%20of%20a%20young%20professional%20walking%20through%20a%20modern%20Seoul%20business%20district%20at%20dusk%2C%20glass%20towers%20and%20warm%20window%20glow%2C%20amber%20and%20charcoal%20tones%2C%20sophisticated%20urban%20mood%2C%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-genre-urban&orientation=portrait',
  },
  {
    key: 'comedy',
    name: '喜剧',
    desc: '轻松解压的爆笑日常，用笑声治愈每一个疲惫的夜晚。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20cinematic%20portrait%20of%20a%20young%20person%20laughing%20warmly%20in%20a%20cozy%20cafe%2C%20sunny%20golden%20afternoon%20light%2C%20vibrant%20orange%20and%20cream%20tones%2C%20joyful%20playful%20atmosphere%2C%20high%20detail%20lifestyle%20photography%2C%20no%20text&width=600&height=800&seq=kd-genre-comedy&orientation=portrait',
  },
  {
    key: 'family',
    name: '家庭',
    desc: '关于亲情与和解的温情群像，看哭无数观众的现实主义佳作。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20tender%20cinematic%20portrait%20of%20a%20Korean%20family%20gathered%20around%20a%20dinner%20table%2C%20soft%20evening%20lamp%20glow%2C%20cozy%20amber%20and%20earth%20tones%2C%20heartwarming%20emotional%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-genre-family&orientation=portrait',
  },
  {
    key: 'crime',
    name: '犯罪',
    desc: '罪案追踪与人性博弈，在黑暗边缘寻找真相与正义。',
    image: 'https://readdy.ai/api/search-image?query=Gritty%20cinematic%20portrait%20of%20a%20determined%20detective%20in%20a%20dim%20interrogation%20room%2C%20harsh%20single%20lamp%20light%20and%20deep%20shadows%2C%20cold%20charcoal%20with%20warm%20red%20accent%2C%20tense%20crime%20drama%20mood%2C%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-genre-crime&orientation=portrait',
  },
];